export default {
  'settings.account.title': 'Configurações de conta',
  'settings.account.personalData': 'Dados pessoais',
  'settings.account.personalData.name': 'Nome',
  'settings.account.personalData.email': 'E-mail',
  'settings.account.personalData.submit': 'Salvar',

  'settings.account.accessData': 'Credenciais de acesso',
  'settings.account.accessData.login': 'Login',
  'settings.account.accessData.oldPassword': 'Senha atual',
  'settings.account.accessData.newPassword': 'Nova Senha',
  'settings.account.accessData.passwordVerify': 'Confirmar senha',
  'settings.account.accessData.message.password.required':
    'Informe a senha do usuário',
  'settings.account.accessData.message.password.min':
    'A senha deve ter no mínimo 8 caracteres',
  'settings.account.accessData.message.password.verify':
    'As senhas precisam ser iguais',
  'settings.account.accessData.submit': 'Salvar',

  'settings.account.personalData.notification.success.title':
    'Dados alterados com sucesso!',
  'settings.account.personalData.notification.success.description':
    'As informações do usuário foram atualizadas com sucesso!',
  'settings.account.personalData.notification.error.title':
    'Erro ao alterar os dados',
  'settings.account.personalData.notification.error.description':
    'Ocorreu um erro ao alterar os dados do usuário.',

  'settings.account.accessData.notification.success.title':
    'Senha alterado com sucesso!',
  'settings.account.accessData.notification.success.description':
    'A senha do usuário foi alterada com sucesso!',
  'settings.account.accessData.notification.error.title':
    'Erro ao alterar a senha!',
  'settings.account.accessData.notification.error.description':
    'Ocorreu um erro ao alterar a senha.',

  'settings.workorderConfiguration.title': 'Configurações de Orçamento',
  'settings.workorderConfiguration.description':
    'Os itens selecionados nesta tela serão as colunas exibidas nas telas de listagem de orçamento do sistema. Essa configuração é somente para o seu usuário.',

  'settings.workorderConfiguration.domain.enums.work_order_field_options.none':
    'Nenhuma',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.number':
    'Número',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.company':
    'Empresa',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.estimator':
    'Orçamentista',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.customer':
    'Cliente',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.insurer':
    'Seguradora',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.plate':
    'Placa',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.vehicle':
    'Veículo',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.observation':
    'Observação',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.estimated_leave_date':
    'Data de Saída Prevista',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.entry_date':
    'Data de Entrada',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.authorization_date':
    'Data de Autorização',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.close_date':
    'Data de Fechamento',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.return_date':
    'Data de Entrega',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.status':
    'Situação',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.type':
    'Tipo',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.cost':
    'Preço',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.localiza':
    'Localiza',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.commission':
    'Comissão',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.complement_tag':
    'Etiqueta',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.situation':
    'Status',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.prisma':
    'Prisma',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.fleet':
    'Frota',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.porto_battery':
    'Bateria (7051)',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.porto_battery_warranty':
    'Garantia de bateria',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.chassi':
    'Chassi',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.motorization':
    'Motorização',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.complement_origin':
    'Origem do orçamento',
  'settings.workorderConfiguration.domain.enums.work_order_field_options.schedule_date':
    'Data de agendamento',
  'settings.workorderConfiguration.update.success': 'Sucesso',
  'settings.workorderConfiguration.update.success.description':
    'Configuração atualizada.',

  'settings.partsConfiguration': 'Configuração de Peças',
  'settings.partsConfiguration.description':
    'Os itens selecionados nesta tela serão as colunas exibidas nas telas de listagem de peças do sistema. Essa configuração é somente para o seu usuário.',

  'settings.partsConfiguration.domain.enums.item_field_options.none': 'Nenhuma',
  'settings.partsConfiguration.domain.enums.item_field_options.bar_code':
    'Cod. Barras',
  'settings.partsConfiguration.domain.enums.item_field_options.manufacturing_code':
    'Cod. Fabricante',
  'settings.partsConfiguration.domain.enums.item_field_options.original_code':
    'Cod. Interno',
  'settings.partsConfiguration.domain.enums.item_field_options.description':
    'Descrição',
  'settings.partsConfiguration.domain.enums.item_field_options.available_stock':
    'Est. Disponível',
  'settings.partsConfiguration.domain.enums.item_field_options.total_stock':
    'Est. Total',
  'settings.partsConfiguration.domain.enums.item_field_options.manufacturer':
    'Fabricante',
  'settings.partsConfiguration.domain.enums.item_field_options.group': 'Grupo',
  'settings.partsConfiguration.domain.enums.item_field_options.sell_price':
    'Pr. de Venda',
  'settings.partsConfiguration.domain.enums.item_field_options.company_code':
    'Cod. Empresa',
  'settings.partsConfiguration.domain.enums.item_field_options.location':
    'Localização',
  'settings.partsConfiguration.domain.enums.item_field_options.image': 'Imagem',
  'settings.partsConfiguration.domain.enums.item_field_options.applications':
    'Aplicações',

  'settings.partsConfiguration.update.success': 'Sucesso',
  'settings.partsConfiguration.update.success.description':
    'Configuração atualizada.',

  'settings.system.title': 'Configurações de sistema',
  'settings.system.systemLanguage': 'Linguagem do sistema',
  'settings.system.systemLanguage.language': 'Língua',

  'settings.registration.systemMasks': 'Máscaras do Sistema',
  'settings.registration.maskPlanAccount':
    'Máscara plano de contas (Exemplo: 9999.9999)',
  'settings.financialConfiguration.domain.enums.financial_field_options.code':
    'Código',
  'settings.financialConfiguration.domain.enums.financial_field_options.company':
    'Empresa',
  'settings.financialConfiguration.domain.enums.financial_field_options.debtor_and_creditor':
    'Credor/Devedor',
  'settings.financialConfiguration.domain.enums.financial_field_options.description':
    'Descrição',
  'settings.financialConfiguration.domain.enums.financial_field_options.document_type':
    'Tipo de documento',
  'settings.financialConfiguration.domain.enums.financial_field_options.due_date':
    'Data de vencimento',
  'settings.financialConfiguration.domain.enums.financial_field_options.pay_date':
    'Data de pagamento',
  'settings.financialConfiguration.domain.enums.financial_field_options.emission_date':
    'Data de emissão',
  'settings.financialConfiguration.domain.enums.financial_field_options.situation':
    'Situação',
  'settings.financialConfiguration.domain.enums.financial_field_options.value':
    'Valor',
  'settings.financialConfiguration.domain.enums.financial_field_options.document_number':
    'Número do documento',
  'settings.financialConfiguration.domain.enums.financial_field_options.installment_tag':
    'Etiqueta',
  'settings.financialConfiguration.domain.enums.financial_field_options.authorization_number':
    'Número de autorização',
};
